/**
 * The app's i18n interpolates `{name}` only (no ICU plurals), so a counted phrase is a set of keys chosen in
 * code: `<base>One` for exactly one, `<base>Other` otherwise, and `<base>None` for zero when the phrase reads
 * differently then ("aucune écriture").
 */
export function pluralKey(base: string, count: number, options: { hasNone?: boolean } = {}): string {
  if (options.hasNone && count === 0) return `${base}None`
  return count === 1 ? `${base}One` : `${base}Other`
}
